/** Türkçe sözlük · kilit. Şekli bu dosya tanımlar; öteki diller ona bağlıdır. */
export const kilit = {
  parola: "Parola",
  profil: "Profil",
  profilAdi: "Profil adı",
  kurtarmaIfadesi: "Kurtarma ifadesi",
  yeniParola: "Yeni parola",
  yeniProfilEkle: "Yeni profil ekle",
  /** Gizlilik perdesindeki logonun metni. */
  perde: "Parafon",

  ekran: {
    baslik: "Kasa kilitli",
    aciliyor: "Açılıyor…",
    ac: "Aç",
    parolamiUnuttum: "Parolamı unuttum",
    ifadeAciklama:
      "Kurulumda kâğıda yazdığınız 24 kelimeyi sırasıyla, aralarında boşluk bırakarak yazın. Büyük/küçük harf önemli değil; her kelimenin ilk dört harfi de yeter. Ardından yeni bir parola belirleyin.",
    ifadeyleAc: "İfadeyle aç",
    parolaylaAc: "Parolayla aç",
    yeniProfilAciklama: "Aynı cihazda ayrı bir kasa: kendi parolası, kendi 24 kelimesi. Var olan profiller etkilenmez.",
  },

  kurulum: {
    profileAdVerin: "Profile bir ad verin.",
    yeniProfil: "Yeni profil",
    sifreleyelim: "Kasanızı şifreleyelim",
    kuralim: "Kasanızı kuralım",
    nasilBaslayalim: "Nasıl başlayalım",
    yeniKasaKur: "Yeni kasa kur",
    yeniKasaKurAciklama: "Boş bir kasa, yeni parola ve 24 kelime.",
    buluttanGetir: "Buluttan getir",
    buluttanGetirAciklama: "Başka cihazdaki kasanızı kasa koduyla, QR'la ya da bulut hesabınızla.",
    tasimaAciklama:
      "Parafon artık kasanızı bu cihazda ŞİFRELİ tutuyor. Mevcut kasanız bir kez, şimdi şifrelenerek taşınacak; bu adım atlanamaz. Taşıma doğrulanmadan eski kopyaya dokunulmaz.",
    yeniAciklama:
      "Kasanız bu cihazda şifreli tutulur. Açmak için bir parola, parolayı unutursanız diye de 24 kelimelik bir kurtarma ifadesi kullanacaksınız.",
    parolaKorur:
      "Aynı parola bulut yedeğinizi de korur. Parola ya da kurtarma ifadesi olmadan kasa açılamaz — Parafon ikisini de bilmez.",
    durumOkunuyor: "Durum okunuyor…",
    profilAyriAciklama:
      "Bu profil bu cihazdaki öbür profillerden tamamen ayrıdır: kendi parolası, kendi 24 kelimesi, kendi bulut depolaması. Başka bir cihazdaki kasanızı getirmek için yukarıdan “Buluttan getir”i seçin.",
    profilAdiIpucu: "Kilit ekranında herkese görünür; gerçek adınız olmak zorunda değil.",
    sifreleniyor: "Kasa şifreleniyor…",
    kuruluyor: "Kuruluyor…",
    sifreleVeTasi: "Şifrele ve taşı",
    kur: "Kur",
    sifrelendiBaslik: "Kasanız şifrelendi",
    sifrelendi: (n: number) =>
      `Kasanız (${n} hareket) şifrelenip taşındı ve doğrulandı; şifresiz eski kopya silindi.`,
    kurtarmaIfadeniz: "Kurtarma ifadeniz",
    kasaAciliyor: "Kasa açılıyor…",
  },

  getir: {
    yedekYok: "Burada Parafon yedeği yok. Doğru yere bağlandığınızdan emin olun.",
    aciklama:
      "Başka bir cihazda kullandığınız kasayı buraya getirin. O kasanın parolası ya da 24 kelimesi geçerli olur; yeni parola belirlemezsiniz.",
    baglanVeListele: "Bağlan ve yedekleri listele",
    kasanizNerede: "Kasanız nerede",
    yedekDosyasi: "Yedek dosyası (en yenisi seçili)",
    neyleAcacaksiniz: "Kasayı neyle açacaksınız",
    parolayla: "Parolayla",
    ifadeyle: "Kurtarma ifadesiyle (24 kelime)",
    ifadeIpucu: "Kelimeler sırasıyla, aralarında boşluk; ilk dört harf yeter.",
    kasaninParolasi: "Kasanın parolası",
    profilAdiIpucu: "Boş bırakırsanız yedekteki kasa adı kullanılır.",
    getiriliyor: "Getiriliyor…",
    kasayiGetir: "Kasayı getir",
    baskaYereBaglan: "Başka yere bağlan",
    dosyadan: "Ya da bu cihazdaki bir yedek dosyasından (.pfai)",
    dosyaSec: "Dosya seç",
    secilenDosya: (ad: string) => `Seçilen dosya: ${ad}`,
  },

  kayip: {
    baslik: "Kasa bu cihazda bulunamadı",
    neOlmus: "Ne olmuş olabilir",
    neOlmusMetin:
      "Parolanız doğru, ama şifreli kasa dosyaları bu tarayıcıda yok ya da okunamıyor. Tarayıcı depolamayı temizlemiş olabilir. Bulut yedeğiniz varsa kasanızı oradan geri getirebilirsiniz.",
    bosKasaylaBasla: "Boş kasayla başla, sonra buluttan geri yükle",
    bosKasaAciklama:
      "Bu cihazda boş bir kasa açılacak. Ardından Ayarlar'dan ya da Hesaplar ekranından buluttaki yedeğinizi geri yükleyin.",
    evetBasla: "Evet, boş kasayla başla",
  },

  ifade: {
    kagidaYazin: "Bu 24 kelimeyi kâğıda yazın",
    kagidaYazinMetin:
      "Parolanızı unutursanız kasanızı ve bulut yedeğinizi açmanın TEK yolu bu kelimeler. Parafon onları saklamaz ve bir daha gösteremez. Ekran görüntüsü almayın, bir dosyaya kaydetmeyin: kâğıda yazıp güvenli bir yere koyun.",
    yazdim: "24 kelimeyi sırasıyla kâğıda yazdım",
    tutmadi: (sira: number) =>
      `${sira}. kelime tutmadı. Kâğıttaki listeye bakın; gerekirse kelimeleri yeniden gösterin.`,
    dogrulamaAciklama: "Kâğıda doğru yazdığınızı görmek için şu kelimeleri yazın:",
    kelime: (sira: number) => `${sira}. kelime`,
    dogrula: "Doğrula",
    yenidenGoster: "Kelimeleri yeniden göster",
  },

  bant: {
    yazilamadi: (hata: string) =>
      `Son değişiklikler cihaza YAZILAMADI: ${hata}. Sekmeyi kapatmayın; yer açıp bir değişiklik daha yapın ya da Ayarlar'dan yedek alın.`,
    oncekiHal:
      "Son yazım yarım kalmış; kasanın bir önceki hâli açıldı. Son birkaç saniyede yaptığınız değişiklikler eksik olabilir.",
    dogrulanmadi: "Kurtarma ifadenizi doğrulamadınız: parolanızı unutursanız kasa açılamaz. ·",
    yeniIfadeAlin: "Ayarlar'da yeni ifade alın",
  },

  /** Hareketsizlikte perde ve "Tutarları gizle" (02.11.2026; yalnızca bu cihaz). */
  gizleme: {
    perdeSuresi: "Hareketsizlikte perde",
    perdeAciklama: "Bu süre dokunulmazsa ekrana perde iner; dokununca kalkar. Yalnızca bu cihazda.",
    kapali: "Kapalı",
    saniye: (n: number) => `${n} sn`,
    acilistaGizle: "Kasa açılınca tutarları gizle",
    perdedeGizle: "Perde inince tutarları gizle",
  },

  /** Gizlilik perdesi tanısı (`?tani=1`, 01.11.2026). */
  tani: {
    baslik: "Perde tanısı",
    aciklama: "Son geçişlerde tarayıcının verdiği sinyaller; yalnızca bu cihazda tutulur.",
    bos: "Henüz kayıt yok: uygulama değiştiriciye geçip geri dönün, sonra sayfayı yenileyin.",
    gorunur: "görünür",
    gizli: "gizli",
    odakVar: "odak var",
    odakYok: "odak yok",
    yenile: "Yenile",
    temizle: "Temizle",
  },

  kart: {
    yolTasi: "Güvenli taşıma — yeni dosya yazılıp eskisinin yerine konuyor",
    yolIkiYuva: "İki yuvalı yazım — tarayıcı dosya taşımayı desteklemiyor, iki kopya dönüşümlü",
    sunucuParolaKisa: (n: number) => `Bulut yedeğiniz Parafon sunucusunda: parola en az ${n} karakter olmalı.`,
    parolaDegisti: "Parola değişti. Bulut yedeği de bundan sonra yeni parolayla açılır.",
    baslik: "Kasa kilidi",
    aciklama: "Kasa bu cihazda şifreli duruyor. Kilitlenince açmak için parola (ya da kurtarma ifadesi) gerekir.",
    simdiKilitle: "Şimdi kilitle",
    kendiligindenKilitle: "Kullanılmayınca kendiliğinden kilitle",
    dakikaSonra: (dk: number) => `${dk} dakika sonra`,
    parolayiDegistir: "Parolayı değiştir",
    yeniIfadeOlustur: "Yeni kurtarma ifadesi oluştur",
    yeniIfadeAciklama: "Eski ifade geçersiz olur. Kâğıdı kaybettiyseniz ya da kurulumda doğrulamadıysanız.",
    yeniIfadeDogrulandi: "Yeni kurtarma ifadesi doğrulandı; eskisi artık geçersiz.",
    tamam: "Tamam",
    acikProfil: "Açık profil:",
    profilSayisi: (n: number) => ` · bu cihazda ${n} profil`,
    adiniDegistir: "Adını değiştir",
    profilDegistir: "Profil değiştir",
    profiliSilSor: "Bu profili bu cihazdan sil",
    yeniProfilKilitli: "Bu cihaza yeni bir profil (ek kasa) eklemek",
    silBaslik: "Profil bu cihazdan silinecek",
    silMetin: (ad: string) =>
      `“${ad}” profilinin bu cihazdaki kasası, yerel yedekleri ve kaydı silinir; geri alınamaz. Buluttaki yedeklere dokunulmaz — oradan başka bir cihaza ya da yeni bir profile geri yüklenebilir.`,
    silOnay: (ad: string) => `Onaylamak için profil adını yazın: ${ad}`,
    profiliSil: "Profili sil",
    baskaKasaAc: "Bu cihazda başka bir kasa aç",
    baskaKasaAciklama: "Başka bir cihazda buluta yedeklediğiniz kasayı bu cihazdakinin yerine koyar.",
    sifreliYazim: (yol: string) => `Şifreli yazım: ${yol}.`,
  },

  parolaAlan: {
    bos: "Parola boş olamaz.",
    enAz: (n: number) => `Yeni parola en az ${n} karakter olmalı.`,
    ayniDegil: "İki parola aynı değil.",
    tekrar: (etiket: string) => `${etiket} (tekrar)`,
    kisaBaslik: (n: number) => `Parola ${n} karakterden kısa`,
    kisaSart: (n: number) =>
      `Parola sıfırlanırken en az ${n} karakter şart. Dört-beş kelimelik bir cümle hem hatırlaması kolay hem de çok daha güçlüdür.`,
    kisaUyari:
      "Bulut yedeğiniz kopyalanırsa kısa bir parola tahminle açılabilir. Dört-beş kelimelik bir cümle hem hatırlaması kolay hem de çok daha güçlüdür. Yine de bu parolayla devam edebilirsiniz.",
  },
};
